import styled from 'styled-components';
const MediaCaption = styled.p.withConfig({
  displayName: "MediaCaption"
})(["color:", ";font-size:", ";margin-top:", ";margin-bottom:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"], ({
  theme
}) => theme.spotlight.color.muted, ({
  theme
}) => theme.spotlight.typography.fontSize.xs, ({
  theme
}) => theme.spotlight.spacing.xs);
MediaCaption.displayName = 'MediaCaption';
export default MediaCaption;